let first_ajax = true;

function triggerSearch(callback) {
    $('.loading').fadeIn();

    searchParams.setFromQuery();

    searchParams.doSearch()
        .done(function (response) {
            buildResponse(response, callback);
        })
        .always(function () {
            $('.loading').fadeOut();
        });
}

function buildResponse(response, callback) {

    let $result_list = $('#listContainer.search-results-ul');
    $result_list.html('');

    let total_results = typeof response.result.hits.total === 'undefined' ? 0 : response.result.hits.total,
        isGeo = response.isGeo || false;

    buildPagination(total_results, (searchParams.getFilterUrlParams().page || 1));

    if (total_results === 0) {
        $('.no-results').show();
    }
    else {
        $('.no-results').hide();

        // Populates the result list
        let total_items_to_display = response.result.hits.total;
        total_items_to_display = (total_items_to_display > 10) ? 10 : total_items_to_display;

        for (let item = 0; item < total_items_to_display; item++) {
            let obj = response.result.hits.hits[item];
            if (typeof obj === 'undefined') break;

            $result_list.append(composeResultItem(obj, isGeo));
        }
        $result_list.find('> li').show();

        $.clicker($('a.phone-hider'), 'strong');
        $(document).foundation('tooltip', 'reflow');

        // Updates filters
        updateFilters(response.result, searchParams.getFilterUrlParams());

        // Scroll page to top if on Search Results page
        if ($('.search-results-page').length) {
            //$('html, body').animate({ scrollTop: 0 }, 500 );
        }
    }
    if (typeof callback !== 'undefined') {
        callback(response);
    }

    if ($('#g-maps-container').length) {
        GoogleMaps.clearMarkers();

        if (response.result.hits.hits.length) {
            GoogleMaps.placeMarks(response.result.hits.hits.map(function (hit) {
                return {
                    name: (hit._source.name || ''),
                    id: (hit._source.doc || ''),
                    address: (hit._source.alternative_address || ''),
                    location: hit._source.location || {lat: '', lon: ''}
                };
            }));
        }
    }

    // ... after everything is done
    first_ajax = false;

    $('.search-query').text(searchParams.getFilterUrlParams().q);

    $('.loading').fadeOut();

}

function triggerRatingList(bedrift, type, $container) {


    $('.ratingList.rBox .loading').fadeIn();

    let useLocation = true;

    let conditions = null,
        name = bedrift.citypart || bedrift.place || bedrift.area || '';

    if (typeof $container !== 'undefined') {
        $container.find('h5 strong').text(name);
    }

    if (type === 'area') {
        searchParams.setGeo(bedrift.geo);
        searchParams.setFilter(bedrift.subjects);
        useLocation = false;
    } else {
        useLocation = false;
        searchParams.setGeo({lat:null,lon:null});
        searchParams.setPath([bedrift.area, bedrift.place, bedrift.citypart]
            .filter(x => x)
            .join('/'));
        conditions = {
            fb: 'should',
            pb: 'should',
        };
    }

    searchParams.setExclude(bedrift.id);

    searchParams.setSize(5);

    searchParams.doTop5List(conditions, useLocation)
        .done(function (response) {
            if (type === 'area') {
                composeTop5($('.result-rating-list'), response);
            } else {
                // buildRatingList(response, bedrift);
                composeTop5($('.top-5-rating ul'), response);
            }
        })
        .always(function () {
            $('.ratingList.rBox .loading').fadeOut();
        });
}
/*
function buildNearAreaList(response, bedrift) {

    let $list = $('.result-rating-list');


    if (response.result.hits.hits.length > 0) {
        $.each(response.result.hits.hits, function (index, element) {
            let obj = element._source,
                item_link = `/bedrift/${obj.doc}/${slugify(obj.name)}`,
                html = `<li class="clearfix"><p>
                        <a href="${item_link}">
                        <strong>${obj.name}<small> (${formatDistance(element.sort)})</small></strong>
                        </a><br />${obj.alternative_address.replace(/\n/, '<br>')}<br />`;
            if (obj.phone) {
                html += `<a href="tel:${obj.phone}"><i class="fa fa-phone" aria-hidden="true"></i> ${obj.phone}</a></p>`;
            }
            $list.append(html);
        });
    } else if (response.result.hits.hits.length === 0) {
        let html = '<p>Ingen treff</p>';

        $list.append(html);
    }

}

function buildRatingList(response, bedrift) {
    var $list = $('.top-5-rating ul');

    if (response.result.hits.hits.length > 0) {
        $.each(response.result.hits.hits, function (index, element) {
            var obj = element._source,
                item_link = '/bedrift/' + obj.doc + '/' + slugify(obj.name),
                html = '<li class="clearfix"><div class="companyName"><a href="' + item_link +
                    '"><strong>' + (index + 1) + '. ' + obj.name + ' </strong></a></div>' + composeResultItemRating(obj.rating) + "</li>";
            $list.append(html);
        });
    } else if (response.result.hits.hits.length == 0) {
        var html = '<p>Ingen treff</p>';

        $list.append(html);
    }
}
*/